"use client";

import Slider from "react-slick";
import UseCase from "./UseCase";
import USE_CASES from "./UseCases.data";
/*import "./UseCases.scss";*/
import Section from "../Section";
import { filterFilledItems } from "../../lib/filterFilledItems";

interface NumberedCardsProps {
  block: {
    title?: string;
    subtitle?: string;
    cards?: Card[];
  };
}

type Card = {
  spot: string;
  title: string;
  description: string;
};

const PLACEHOLDER_CARD: Card = {
  spot: "2",
  title: "Placeholder",
  description: "Please fill out another card before publishing",
};

export default function NumberedCards({ block }: NumberedCardsProps) {
  const {
    title = "Use Case",
    subtitle = `A financial institution using MotionScore to calculate the \
    probability of a default when a person applies for a personal loan.`,
    cards,
  } = block;
  const filledCards = filterFilledItems(cards, [
    "spot",
    "title",
    "description",
  ]);

  const usedCards =
    filledCards?.length === 1
      ? [...filledCards, PLACEHOLDER_CARD]
      : filledCards?.length
        ? filledCards
        : USE_CASES;
  const renderedUseCases = usedCards.map((useCase) => (
    <UseCase key={useCase.title} {...useCase} />
  ));

  return (
    <Section title={title} className="UseCases pt-5">
      <div className="row">
        <div className="text-center">
          <p className="lead">{subtitle}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Slider {...SETTINGS}>{renderedUseCases}</Slider>
        </div>
      </div>
    </Section>
  );
}

const SETTINGS = {
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 200,
  autoplay: true,
  autoplaySpeed: 3500,
  pauseOnFocus: true,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
